import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "preact/hooks";
import { ThreeDS } from "../../api/Client";
export const IframeThreeDsAuthorizationWindow = ({ orderCode, authorizationUrl, onComplete }) => {
    const [shouldOpen, setShouldOpen] = useState(false);
    useEffect(() => {
        setShouldOpen(typeof orderCode === 'string' && typeof authorizationUrl === 'string');
    }, [orderCode, authorizationUrl]);
    const intervalRef = useRef();
    const checkProcessCompletion = useCallback(async () => {
        if (orderCode) {
            const { data } = await ThreeDS.getStatus(orderCode);
            if (data.status === 'END') {
                onComplete(data.errorMessages);
                setShouldOpen(false);
                if (intervalRef.current) {
                    clearInterval(intervalRef.current);
                }
            }
        }
    }, [orderCode, onComplete]);
    useEffect(() => {
        if (shouldOpen) {
            intervalRef.current = setInterval(checkProcessCompletion, 1000);
        }
    }, [shouldOpen]);
    return (_jsxs("section", Object.assign({ className: `modal ${shouldOpen ? 'is-active is-clipped' : ''}` }, { children: [_jsx("div", { className: "modal-background" }, void 0),
            _jsx("div", Object.assign({ className: "modal-content", style: { padding: '1.25.rem' } }, { children: authorizationUrl && _jsx("iframe", { className: "three-ds-window", src: authorizationUrl }, void 0) }), void 0),
            _jsx("button", { class: "modal-close is-small", "aria-label": "close" }, void 0)] }), void 0));
};
